function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useCallback, useRef, useState } from 'react';
import { getElementScroll, useScroll, useScrollTo } from '@bydesign-ui/hooks';
import { classnames } from '@bydesign-ui/utils';
import { usePrefixCls } from '@byte-design/config';
import { ToTopOne } from '../../common/icons';
export function BackTop(props) {
  var _props$visibleHeight = props.visibleHeight,
      visibleHeight = _props$visibleHeight === void 0 ? -1 : _props$visibleHeight,
      _props$duration = props.duration,
      duration = _props$duration === void 0 ? 450 : _props$duration,
      _props$getContainer = props.getContainer,
      getContainer = _props$getContainer === void 0 ? function () {
    return typeof window !== 'undefined' ? document.documentElement : null;
  } : _props$getContainer,
      className = props.className,
      children = props.children,
      _props$style = props.style,
      style = _props$style === void 0 ? {} : _props$style,
      extra = _objectWithoutProperties(props, ["visibleHeight", "duration", "getContainer", "className", "children", "style"]);

  var _useState = useState(false),
      _useState2 = _slicedToArray(_useState, 2),
      isVisible = _useState2[0],
      setVisible = _useState2[1];

  var scrollInfo = useRef(getElementScroll(getContainer()));
  var handleScroll = useCallback(function () {
    var container = getContainer();
    var newInfo = getElementScroll(container);

    if (scrollInfo.current.scrollTop !== newInfo.scrollTop) {
      scrollInfo.current = newInfo;
      setVisible(newInfo.scrollTop > visibleHeight);
    }
  }, []);
  useScroll(function () {
    return true;
  }, handleScroll);

  var _useScrollTo = useScrollTo(getContainer(), 'top', 0, duration, function () {
    return isVisible;
  }, {
    animateType: 'easeInOut'
  }),
      startScroll = _useScrollTo.startScroll;

  var handleBackTop = function handleBackTop() {
    startScroll();
  };

  var cls = classnames(usePrefixCls('backtop'), className);
  var iconCls = usePrefixCls('backtop-icon');
  return React.createElement("div", Object.assign({}, extra, {
    onClick: handleBackTop,
    className: cls,
    style: _objectSpread(_objectSpread({}, style), {}, {
      display: isVisible ? style.display || undefined : 'none'
    })
  }), children ? children : React.createElement("span", {
    className: iconCls
  }, React.createElement(ToTopOne, null)));
}